import Model from "../../../model/Model";
import {ISnapshotDetail} from "../../../model/Snapshot";
import IModelItem from "../../../model/IModelItem";
import {useEffect, useState} from "react";
import Person from "../../../model/Person";
import {Box, Grid, Typography} from "@mui/material";
import ChatbotOpenImg from "../../../images/ChatbotOpen.png";
import DialogButton from "../../../components/form/DialogButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import * as React from "react";
import PersonEditDialog from "./PersonEditDialog";
import {Gender, MaritalStatus} from "../../../API";
import {createUUID} from "../../../stores/StoreUtilities";
import UserSetting, {IQuickStartSettings} from "../../../model/UserSetting";
import globalStyles from "../../../styles/globalStyles";
import QuickStartWidget from "../dashboard/widgets/QuickStartWidget";


const TimelineQuickStart = ({
  step,
  model,
  quickStartUserSetting,
  onSave,
  onNext,
  onExit
}: {
  step?: string
  model: Model
  onSave(item: IModelItem): void
  quickStartUserSetting?: UserSetting
  onNext(settings: IQuickStartSettings): void
  onExit(settings: IQuickStartSettings): void
}) => {
  const [person, setPerson] = useState<Person | undefined>()
  const [instructions, setInstructions] = useState<string>("")

  const styles = {
    finn: {
      fontStyle:"italic"
    }
  }

  useEffect(() => {
    if (person) {
      return
    }
    if (step === "Person1")
    {
      if (model.persons.length === 0) {
        setPerson(new Person({
          id: createUUID(),
          accountId: model.accountId,
          userId: model.userId,
          modelId: model.id,
          nickname: "",
          birthDate: null,
          retireDate: null,
          gender: Gender.Male,
          maritalStatus: MaritalStatus.Single,
        }))
        setInstructions("Let's start by adding yourself (or the first person in this model).")
      } else if (model.persons.length >= 1) {
        setPerson(model.persons[0])
        setInstructions("Let's start by confirming your details (or the first person in this model).")
      }
    } else if (step === "Person2") {
      if (model.persons.length === 1 && model.persons[0].maritalStatus === MaritalStatus.Married) {
        setPerson(new Person({
          id: createUUID(),
          accountId: model.accountId,
          userId: model.userId,
          modelId: model.id,
          gender: model.persons.length > 0 && model.persons[0].gender === Gender.Male ? Gender.Female : Gender.Male,
          maritalStatus: model.persons.length > 0 ? MaritalStatus.Married : MaritalStatus.Single,
        }))
        setInstructions("Please enter the details for your spouse (or the second person in this model).")
      } else if (model.persons.length === 2) {
        setPerson(model.persons[1])
        setInstructions("Please review the details for your spouse (or the second person in this model).")
      }
    } else {
      setInstructions("Please review the people you have added to this model. Press Next Step to continue.")
    }
  }, [step])

  const handleSave = async (item: IModelItem, snapshotItem?: ISnapshotDetail) => {
    const per = item as Person
    await onSave(per)
    setPerson(undefined)
    if (step === "Person1" && per.maritalStatus === MaritalStatus.Married) {
      onNext({status: "Active", view: "timeline", step: "Person2"})
    } else {
      onNext({status: "Active", view: "timeline", step: "People"})
    }
  }

  const handleNext = (event: any) => {
    if (model.persons.length > 1 || model.persons[0].maritalStatus === MaritalStatus.Single) {
      onNext({status: "Active", view: "networth", step: "LiquidAssets"})
    } else {
      onNext({status: "Active", view: "timeline", step: "Person2"})
    }
  }

  return (
    <Grid container spacing={1} sx={{mt: 0, px: 1}}>
      <Grid item xs={12}>
        <QuickStartWidget model={model} quickStartUserSetting={quickStartUserSetting} onExit={onExit}/>
      </Grid>
      <Grid item xs={12} display="flex" alignItems="flex-start">
        <img src={ChatbotOpenImg} alt="chatbot" height={36} style={{borderRadius: "20px", marginRight: 8}}/>
        <Box pt={0}>
          <Typography variant="body2" sx={styles.finn} gutterBottom>
            Hi, I'm Finn, your virtual retirement assistant, here to help you quickly get started with your retirement model.
          </Typography>
          <Typography variant="h5" color="primary" gutterBottom>People</Typography>
          <Typography variant="body2" sx={styles.finn}>
            {instructions}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} sx={{ml: "44px"}}>
        {person &&
          <PersonEditDialog person={person} model={model} open
                            onSave={handleSave}
                            onClose={() => setPerson(undefined)} quickForm/>
        }
      </Grid>
      <Grid item xs={12} sx={{ml: "44px"}}>
        {!person &&
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            <DialogButton variant="primary" size="medium" onClick={handleNext} type="button" customClassName={globalStyles.nextButton}>
              Next Step <ChevronRightIcon/>
            </DialogButton>
          </Box>
        }
      </Grid>
    </Grid>
  )
}

export default TimelineQuickStart